import { render, staticRenderFns } from "./labour-protection-settings.vue?vue&type=template&id=449cb675&"
import script from "./labour-protection-settings.vue?vue&type=script&lang=js&"
export * from "./labour-protection-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports